// extracted by mini-css-extract-plugin
export default {"indicator":"AutosaveIndicator_indicator__pE63x","offline":"AutosaveIndicator_offline__IW1ko","spinning":"AutosaveIndicator_spinning__HpIuS","spin":"AutosaveIndicator_spin__hkoBu"};